<!-- Sidebar -->
<nav id="sidebar" [ngClass]="{'active': sidebarStatus === true}">
  <div class="sidebar-header animated bounce fadeIn">
    <div class="row">
      <div class="col-4 center line-height-100 pr0">
        <img *ngIf="!imageUser" [src]="logoCommunity" class="community-image br-circle" alt="comunidad">
        <img *ngIf="imageUser" [src]="imageUser" class="community-image br-circle" alt="comunidad">
      </div>
      <div class="col-8 text-left pt15">
        <label class="font-normal community txt-item">{{communityInSession}}</label>
        <label class="font-normal community-secondary">{{'GENERAL.IDENTIFIER' | translate }} {{codeCommunityInSession | rut}}</label>
        <label class="font-normal community-secondary">{{ 'UPDATED_DEBT.PROPERTY' | translate }}: {{property}}</label>
      </div>
    </div>
  </div>

  <!-- Sidebar Links -->
  <ul *ngIf="menu" class="components mt10 animated bounce fadeIn">
    <li *ngFor="let module of menu; let i=index;">
      <a routerLinkActive="active" *ngIf="module.link" id="{{module.link}}" [routerLink]="module.link">
        <label *ngIf="module.link === urlActive">
          <i class="fal {{module.icon}} mr10 svg-width txt-secondary"></i>
        </label>
        <label *ngIf="module.link !== urlActive">
          <i class="fal {{module.icon}} mr10 svg-width"></i>
        </label>
        <span class="txt-item">{{ module.name | translate}}</span>
      </a>
      <a routerLinkActive="active" *ngIf="!module.link" data-toggle="collapse" [attr.data-target]="'#' + module.entity" aria-expanded="false">
        <label *ngIf="module.link === urlActive">
          <i class="fal {{module.icon}} mr10 svg-width txt-secondary"></i>
        </label>
        <label *ngIf="module.link !== urlActive">
          <i class="fal {{module.icon}} mr10 svg-width"></i>
        </label>
        <span class="txt-item">{{ module.name | translate}}</span>
      </a>
      <ul *ngIf="!module.link" class="collapse" id="{{module.entity}}">
        <li *ngFor="let sub of module.sub">
          <div class="circle ml25"></div>
          <a *ngIf="sub.link" class="pl40" routerLinkActive="active" [routerLink]="sub.link">{{ sub.name | translate}}
          </a>
          <a *ngIf="!sub.link" class="pl40" data-toggle="collapse" [attr.data-target]="'#' + sub.entity" aria-expanded="false">{{
            sub.name | translate}}</a>
          <ul *ngIf="!sub.link" class="collapse" id="{{sub.entity}}">
            <li *ngFor="let subMenu of sub.sub">
              <div class="circle ml45"></div>
              <a *ngIf="subMenu.link" class="pl60" routerLinkActive="active" [routerLink]="subMenu.link">{{subMenu.name
                | translate}}</a>
              <a *ngIf="!subMenu.link" class="pl60" data-toggle="collapse" [attr.data-target]="'#' + subMenu.entity"
                aria-expanded="false">{{ subMenu.name | translate }}</a>
              <ul *ngIf="!subMenu.link" class="collapse" id="{{subMenu.entity}}">
                <li *ngFor="let subMenu2 of subMenu.sub">
                  <div class="circle ml65"></div>
                  <a class="pl80" routerLinkActive="active" [routerLink]="subMenu2.link">{{subMenu2.name | translate}}</a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
</nav>



// WEBPACK FOOTER //
// ./src/app/layout/sidebar/sidebar.component.html